import _filter from 'lodash/filter'

const pluckTaxConsultationId = (_, { taxConsultationId }) => taxConsultationId

const getTaxConsultationTopicsItems = (state) => state.taxConsultationTopics.items
export const getIsFetchingTaxConsultationTopics = (state) => state.taxConsultationTopics.isFetching
export const getIsFetchSuccessfulTaxConsultationTopics = (state) => state.taxConsultationTopics.fetchSuccessful

export const getTaxConsultationTopicsByTaxConsultationId = (state, ownProps) => {
    const topics = getTaxConsultationTopicsItems(state)
    const taxConsultationId = pluckTaxConsultationId(state, ownProps)

    return _filter(topics, { taxConsultationId })
}
